import { Box, Button } from '@mui/material'
import { useEffect, useState } from 'react'
import { Item, SingleInputModal2 } from '../../common/snippets'
import LineInput from '../../common/lineinput'
import DropDownOA from '../../common/dropDownOA'
import { API_CACHE_DURATION, PARENT_COMPANY_MODE, SEL_DESTINATION_CITY, urls } from '../../common/constants'
import { paymentModes, paytypes } from '../../common/paymentsMode'
import { connect } from 'react-redux'
import * as iid from '../../common/bookingElementId'
import moment from 'moment'
import { DEMO_COMPANY, GT_COMPANY_ID, STA_COMPANY_ID } from '../../../helper/companyIdhardcode'
import {
  SenderReceiverDetailChange,
  getBranchConfigOrEwbillinfo,
  getBranchList,
  getBranchListForAdminUpdate,
  updateAlert,
  updateDestBrnch,
  updateDestCity,
  updateModal,
} from '../../../store/common/common_action'
import LineInputV2 from '../../common/lineinputV2'
import { alphaNumericSpaceFilter, focusElemnt, getInt, isEmpty, isNull, isValidGSTNo, lineInputNavigation2, navigation2 } from '../../common/helper'
import { useRef } from 'react'
import GstnValidationUi from './GstnValidationUi'
import DestinationChangeRemarkMode from './DestinationChangeRemarkMode'
import Datepicker from '../../common/datePicker'
import { SENDER_PHONE } from '../../common/error_strings'
import { companySettingsAtom, luggageSendOTP } from '../../common/jotaiState/commonStateAtoms'
import { useAtom, useSetAtom } from 'jotai'
import { GetRequest, PostRequest } from '../../common/api'
import { alertAtom, globalLoaderAtom } from '../../common/jotaiState/globalStateAtoms'
import { useTranslation } from '../../../i18n/I18nProvider'

const payTypesForSendRecDetails = [
  { typeId: 1, name: 'PAID' },
  { typeId: 2, name: 'To-Pay' },
  { typeId: 6, name: 'PAID(Manual)' },
  { typeId: 7, name: 'To-Pay(Manual)' },
  { typeId: 5, name: 'On Account' },
  { typeId: 10, name: 'On Account(Man' },
]
const SenderReceiverTab = (props) => {
  const { translations } = useTranslation()
  const au = translations?.adminUpdate || {}
  const {
    data,
    updateModal,
    SenderReceiverDetailChange,
    updateAlert,
    updateDestCity,
    updateDestBrnch,
    getBranchList,
    getBranchListForAdminUpdate,
  } = {
    ...props,
  }
  const [gstnModal, setGstnModal] = useState(false)
  const [otpPopupVisible, setOtpPopupVisible] = useState(false)
  const [otpInfo, setOtpInfo] = useState({
    error: false,
    otpp: '',
    status: null,
  })
  const [billNo, setBillNo] = useState('')
  const [billDate, setBillDate] = useState(moment(new Date()))
  const [billAmount, setBillAmount] = useState('')
  const [otp, setOTP] = useState('')
  const { common } = data
  let { loginData, cityList, destBrnchList, parentCompnayData, companyBookingPermission, destCity, adminBranchList, roleRights } = {
    ...common,
  }
  const [companySettings] = useAtom(companySettingsAtom)
  const { UseToPayAsCOD = 0 } = companySettings
  const [gstnValidationData, setGstnValidationData] = useState('')
  const [senderPartyList, setSenderPartyList] = useState([])
  const [selSenderParty, setSelSenderParty] = useState('')
  const [selReceiverParty, setSelReceiverParty] = useState('')
  const [paymentTypes, setPaymentTypes] = useState(paymentModes)
  const [selectLr, setSelectLr] = useState(props?.selectLr)
  const [destCitiesList, setDestCityList] = useState([])
  const [clearBranch, setClearBranch] = useState(false)
  const [selectedDestBranchName, setSelectedDestBranchName] = useState(selectLr?.DestinationBranchName || '')
  const [updatedVal, setUpdatedVal] = useState({
    BookingID: selectLr?.BookingID,
    CompanyID: loginData.intCompanyID,
    UserID: loginData.intUserID,
    PaymentType: selectLr?.PaymentType,
    PaymentTypeId: selectLr?.PaymentTypeID,
    Sender: selectLr?.Sender,
    SenderMobileNo: selectLr?.SenderMobileNo,
    SenderEmail: selectLr?.SenderEmailID?.toLowerCase(),
    SenderGSTN: selectLr?.SenderGSTN,
    RecName: selectLr?.RecName,
    RecMobileNo: selectLr?.RecMobileNo,
    RecEmail: selectLr?.ReceiverEmailID?.toLowerCase(),
    ReceiverGSTN: selectLr?.ReceiverGSTN,
    DestCityID: selectLr?.DestinationCityID,
    DestBranchID: selectLr?.DestinationBranchID,
    ManualLRNo: selectLr?.ManualLRNo,
    billNo: selectLr?.PartyBillNo,
    billAmount: selectLr?.PartyBillAmount,
    billDate: selectLr?.PartyBillDate,
  })
  const [showModel, setShowModel] = useState(false)
  const [textAreaValue, setTextAreaValue] = useState('')
  const OwnparentCompnayData = parentCompnayData.length ? parentCompnayData[PARENT_COMPANY_MODE] : {}
  const { ParentCompanyID } = OwnparentCompnayData
  const shouldValidateGSTN = ![GT_COMPANY_ID].includes(loginData.intCompanyID)
  const usePrevious = (value) => {
    const ref = useRef()
    useEffect(() => {
      ref.current = value
    })
    return ref.current
  }

  const paytypeList = payTypesForSendRecDetails.map((item) => {
    if (!UseToPayAsCOD) return item
    if (item.typeId === 2) {
      return { ...item, name: 'COD' }
    } else if (item.typeId === 7) {
      return { ...item, name: 'COD (Manual)' }
    }
    return item
  })
  const setLoader = useSetAtom(globalLoaderAtom)
  const setAlert = useSetAtom(alertAtom)
  const prevcityList = usePrevious(cityList)
  const updatedPayType =
    UseToPayAsCOD !== 1
      ? paymentModes
      : paymentModes
          .map((val) => {
            if (val.typeId === 2) {
              return { ...val, name: 'COD', type: 'COD' }
            }
            if (val.typeId === 7) {
              return { ...val, name: 'COD(Manual)', type: 'COD Manual' }
            }
            return val
          })
          .filter((p) => {
            if (p.typeId === 4) return false
            return true
          })
  const handlePartyListData = (data) => {
    setLoader(true)
    PostRequest(urls.getPartyList, data)
      .then((res) => {
        if (res.status !== 'Success') {
          throw new Error(res?.ErrMessage || 'Request Failed')
        }
        if (!Array.isArray(res.Data) || res.Data.length === 0) {
          throw new Error('No Data Found')
        }
        setSenderPartyList(res.Data)
        const data = res.Data.filter((item) => item.PartyID === selectLr.SendingPartyID)
        const data1 = res.Data.filter((item) => item.PartyID === selectLr.RecPartyID)
        setSelSenderParty(data[0])
        setSelReceiverParty(data1[0])
      })
      .catch((err) => {
        setSenderPartyList([])
        setAlert({ show: true, msg: err.message, nextId: '' })
      })
      .finally(() => {
        setLoader(false)
      })
  }
  const handlePaymentListData = (data) => {
    setLoader(true)
    GetRequest(urls.getBranchPaymentTypeConfigDetails, data)
      .then((res) => {
        if (res.status !== 'Success') {
          throw new Error(res?.ErrMessage || 'Request Failed')
        }
        if (!Array.isArray(res.Data.Table)) {
          throw new Error('No Data Found')
        }
        const table1 = res.Data.Table?.[0] || {}
        const table2 = res.Data.Table1?.[0] || {}
        let paymentData = updatedPayType.filter(
          (p) => (table1[p.isActive] === 1 || table1[p.isActive2] === 1) && (table2[p.isActive] === 1 || table2[p.isActive2] === 1)
        )
        setPaymentTypes(paymentData)
      })
      .catch((err) => {
        setPaymentTypes([])
        setAlert({ show: true, msg: err.message, nextId: '' })
      })
      .finally(() => setLoader(false))
  }

  useEffect(() => {
    const desinationBranch = adminBranchList.find((a) => a.BranchID === updatedVal.DestBranchID)
    const obj = {
      CompanyID: loginData?.intCompanyID,
      FromBranchID: selectLr?.BookingBranchID,
      ToCityID: desinationBranch?.CityID,
      ToBranchID: desinationBranch?.BranchID,
      ToStateID: desinationBranch?.StateID,
    }
    if (desinationBranch) {
      handlePaymentListData(obj)
    }
  }, [updatedVal.DestBranchID, adminBranchList])
  useEffect(() => {
    if (!selectLr) return
    const apiPayloadBase = {
      intPartyID: 0,
      intCompanyID: loginData.intCompanyID,
      strPartyName: '',
      strContactPerson: '',
      intIsCreditParty: 0,
      intIsActive: 1,
      intIsDeleted: 0,
    }
    const cityIDs = [
      selectLr.IsSenderParty === 1 && selectLr.BookingCityID,
      selectLr.IsReceivedParty === 1 && selectLr.DestinationCityID,
    ].filter(Boolean)
    cityIDs.forEach((intCityID) => handlePartyListData({ ...apiPayloadBase, intCityID }))
  }, [selectLr])

  useEffect(() => {
    focusElemnt(iid.senderName)
    setBillNo(selectLr?.PartyBillNo)
    setBillAmount(selectLr?.PartyBillAmount)
    setBillDate(moment(new Date(selectLr?.PartyBillDate)))
    setSelectedDestBranchName(selectLr?.DestinationBranchName || '')
  }, [selectLr])

  useEffect(() => {
    if (cityList.length && JSON.stringify(prevcityList) !== JSON.stringify(cityList)) {
      // const destCities = cityList.filter(({ CityID }) => loginData.intBranchCityID != CityID) || []
      const destCities = cityList || []
      setDestCityList(destCities)
      if (destCities.length) {
        updateDestCity(destCities[0])
      }
    }
  }, [cityList])
  useEffect(() => {
    if (adminBranchList.length && ParentCompanyID > 0 && !isEmpty(companyBookingPermission) && !isEmpty(companySettings)) {
      const branchPermisson = companyBookingPermission?.Table1.filter(
        (el) => el.ParentCompanyID === ParentCompanyID && el.ChildCompanyID === loginData.intCompanyID
      )
      const HasOwnBookingRestricted = companySettings.HasOwnBookingRestricted
      let filteredBranches = adminBranchList.filter((brnch) => brnch.CargoHasDelivery === 1)
      let IsSharedChildCompany = 0
      if (HasOwnBookingRestricted === 1) {
        filteredBranches = filteredBranches.filter((brnch) => brnch.CompanyID !== loginData.intCompanyID)
      }
      if (ParentCompanyID === 10) {
        if (branchPermisson.length) IsSharedChildCompany = branchPermisson[0].IsSharedChildCompany
        if (IsSharedChildCompany === 0) {
          filteredBranches = filteredBranches.filter((brnch) => brnch.CargoHasDelivery_GT === 1)
        } else if (IsSharedChildCompany === 1) {
          filteredBranches = filteredBranches.filter((brnch) => brnch.IsOwnChildCompanyDel_GT === 1)
        }
      }
      if (filteredBranches.length) {
        updateDestBrnch(filteredBranches[0])
      }
    }
  }, [JSON.stringify(adminBranchList)])
  useEffect(() => {
    if (!clearBranch) return
    const firstBranch = adminBranchList?.find(
      (brnch) => brnch.CargoHasDelivery === 1 && (brnch.CityID == null || brnch.CityID == updatedVal.DestCityID)
    )
    if (!firstBranch) return
    setUpdatedVal((prev) => ({ ...prev, DestBranchID: firstBranch.BranchID }))
    setSelectedDestBranchName(firstBranch.BranchName || '')
    setClearBranch(false)
  }, [clearBranch, updatedVal.DestCityID, JSON.stringify(adminBranchList)])
  useEffect(() => {
    const obj = {
      intUserID: loginData?.intUserID,
      intCompanyID: loginData?.intCompanyID,
      intCityID: selectLr?.DestinationCityID,
      intBookingBranchID: -1,
    }
    getBranchListForAdminUpdate(obj)
  }, [])
  const handleBranchList = (cityId) => {
    const obj = {
      intUserID: loginData?.intUserID,
      intCompanyID: loginData?.intCompanyID,
      intCityID: cityId,
      intBookingBranchID: -1,
    }
    getBranchListForAdminUpdate(obj)
  }
  useEffect(() => {
    if (destCity?.CityID) {
      getBranchList(loginData, destCity.CityID, 2, true, API_CACHE_DURATION)
    }
  }, [destCity?.CityID])

  useEffect(() => {
    if (destBrnchList.length) {
      let filteredBranches = destBrnchList.filter((brnch) => brnch.CargoHasDelivery === 1)
      if (filteredBranches.length) {
        updateDestBrnch(filteredBranches[0])
      }
    }
  }, [JSON.stringify(destBrnchList)])

  const [oldDestCity, setOldDestCity] = useState('')
  const [oldDestBranch, setOldBranch] = useState('')
  useEffect(() => {
    setOldDestCity(selectLr?.DestinationCityID)
    setOldBranch(selectLr?.DestinationBranchID)
  }, [])
  const manualTypes = [paytypes.PAID_MANUAL, paytypes.TO_PAY_MANUAL, paytypes.ONACCOUNT_MANUAL]
  const isManualPayment = manualTypes.includes(updatedVal.PaymentTypeId)
  const getCurrentInputValue = (id, fallback = '') => {
    const input = document.getElementById(id)
    return input ? input.value : fallback || ''
  }
  const UpdateSendRecDetails = (isForced = false) => {
    const currentSenderGSTN = getCurrentInputValue(iid.SenderGSTN, updatedVal.SenderGSTN)
    const currentReceiverGSTN = getCurrentInputValue(iid.ReceiverGSTN, updatedVal.ReceiverGSTN)
    let remarkFlag = [GT_COMPANY_ID,DEMO_COMPANY].includes(loginData.intCompanyID) ? false :oldDestCity !== updatedVal?.DestCityID || oldDestBranch !== updatedVal?.DestBranchID
    if (adminBranchList.length > 0) {
      //Condition > If Paid/ToPay Manual Selected - Manual LR No is Compulsory
      if (isManualPayment && (!updatedVal.ManualLRNo || updatedVal.ManualLRNo.trim() === '')) {
        handleAlert(au.manualLrNoCompulsory || 'Manual LR No is Compulsory!', iid.manualLr)
        return
      } else if (
        companySettings?.IsSenderNoCompulsory === 1 &&
        (updatedVal.SenderMobileNo === '' || updatedVal.SenderMobileNo?.length < loginData.MobileNoLLimit)
      ) {
        handleAlert(au.pleaseEnterValidSenderMobile || 'Please Enter Valid Sender Mobile Number', iid.SenderMobileNo)
      } else if (
        companySettings?.IsRecvNoCompulsory === 1 &&
        (updatedVal.RecMobileNo === '' || updatedVal.RecMobileNo?.length < loginData.MobileNoLLimit)
      ) {
        handleAlert(au.pleaseEnterValidReceiverMobile || 'Please Enter Valid Receiver Mobile Number', iid.RecMobileNo)
      } else if (!updatedVal.DestCityID) {
        handleAlert(au.pleaseSelectDestinationCity || 'Please Select Desination City', iid.destinationCity)
      } else if (!updatedVal.DestBranchID) {
        handleAlert(au.pleaseSelectDestinationBranch || 'Please Select Desination Branch', iid.destbranch)
      } else {
        if (remarkFlag && !textAreaValue) {
          setShowModel(true)
          // updateSendetReceiverDetails()
        } else {
          if (!shouldValidateGSTN || isValidGSTNo(currentReceiverGSTN)) {
            const obj = {
              BookingID: updatedVal.BookingID,
              CompanyID: updatedVal.CompanyID,
              UserID: updatedVal.UserID,
              PaymentType: updatedVal.PaymentTypeId,
              Sender: updatedVal.Sender,
              SenderMobileNo: updatedVal.SenderMobileNo,
              SenderEmail: updatedVal.SenderEmail,
              SenderGSTN: currentSenderGSTN,
              RecName: updatedVal.RecName,
              RecMobileNo: updatedVal.RecMobileNo,
              RecEmail: updatedVal.RecEmail,
              ReceiverGSTN: currentReceiverGSTN,
              DestCityID: updatedVal.DestCityID,
              DestBranchID: updatedVal.DestBranchID,
              // ManualLRNo: [paytypes.PAID_MANUAL,paytypes.TO_PAY_MANUAL, paytypes.ONACCOUNT_MANUAL].includes(updatedVal.PaymentTypeId) ? updatedVal.ManualLRNo : '',
              ManualLRNo: updatedVal.ManualLRNo,
              Remarks: textAreaValue || '',
              IsOTP: isForced ? 1 : 0,
              PartyBillAmount: billAmount,
              PartyBillNo: `${billNo}~${moment(billDate).format('DD-MMM-YYYY')}`,
              SenderPartyID: selectLr?.IsSenderParty === 1 ? selSenderParty?.PartyID : 0,
              ReceiverPartyID: selectLr?.IsReceivedParty === 1 ? selReceiverParty?.PartyID : 0,
              senderGSTNState: updatedVal?.senderGSTNState || '',
              recvGSTNState: updatedVal?.recvGSTNState || '',
            }
            handleClose()
            SenderReceiverDetailChange(
              obj,
              props.setOnClosePopup,
              loginData.IsAdmin,
              updateModal,
              props.updateData,
              sendOTPForForceTransfer
            )
          } else {
            handleAlert(au.enterValidReceiverGstNumber || 'Enter Valid Receiver GST Number')
          }
        }
      }
      //
    } else {
      handleAlert(au.selectedCityDoesNotHaveBranch || 'Selected City Does Not Having Branch!', iid.destinationCity)
    }
  }
  const handleAlert = (msg = false, nextId = '') => {
    if (typeof msg === 'string' && !isNull(msg)) {
      updateAlert({ show: true, msg, nextId })
    } else {
      updateAlert({ show: false, msg: '', nextId: '' })
      focusElemnt(nextId)
    }
  }
  const handleChange = (e, type) => {
    const { value } = e.target
    if (type === 'billDate') {
      setBillDate(`${billNo}~${value}`)
    } else if (type === 'billNo') {
      setBillNo(value)
    } else if (type === 'billAmt') {
      setBillAmount(value)
    }
  }

  const sendOTPForForceTransfer = (type) => {
    const data = {
      StrEventType: type,
      intCompanyID: loginData.intCompanyID,
      intUserID: loginData.intUserID,
      intBookingID: 0,
      intMode: 4,
      strBookingIDs: 0,
      intOTPToUserID: 0,
      strContactNo: '',
    }
    luggageSendOTP(data).then((res) => {
      if (res.Status) {
        setOtpPopupVisible(true)
        setOtpInfo({ otpp: res.OTP, status: res.Status, error: res.ErrMessage })
      } else {
        setOtpPopupVisible(false)
        setOtpInfo({ otpp: res.OTP, status: res.Status, error: res.ErrMessage })
      }
    })
  }
  const ShowStickerCopyPopup = () => {
    const data = {
      headTxt: au.submitOtp || 'Submit OTP',
      inputId: 'no_of_copy',
      inputLabel: 'Enter OTP',
      inputName: 'no_of_copy',
      inputValue: otp,
      mainButtonId: 'sticker_copy_save',
    }
    const functions = {
      updateModal: setOtpPopupVisible,
      onChangeInput: setOTP,
      onClickButton: (e) => {
        if (otp === otpInfo.otpp) {
          UpdateSendRecDetails(true)
        } else {
          handleAlert(au.pleaseEnterValidOtp || 'Please Enter Valid OTP')
        }
      },
      inputFilter: getInt,
      onCloseCallback: setOtpPopupVisible,
    }
    return <SingleInputModal2 data={data} functions={functions} />
  }

  const handleClose = () => {
    setShowModel(false)
  }
  const mobileNumberFilter = (value) => {
    value = value.replace(/\D/g, '')
    if (value.length > loginData?.MobileNoULimit) value = value.slice(0, loginData?.MobileNoULimit)
    if (companySettings?.DefaultCurrencyID === 2) {
      return value
    }
    if (value.length > 0 && !/^[6-9]/.test(value)) {
      value = ''
    }
    return value
  }
  const validateGSTN = (data, isRecve, navigation) => {
    setLoader(true)
    GetRequest(urls.validateGSTN, data)
      .then((res) => {
        if (res.status !== 'True' && !res.error) {
          throw new Error(res?.ErrMessage || 'Request Failed')
        }
        if (!Array.isArray(res.Data) || res.Data.length === 0) {
          throw new Error(au.invalidGstn || 'Invalid GSTN')
        }
        const gstData = res.Data[0]
        setUpdatedVal({
          ...updatedVal,
          [isRecve ? 'ReceiverGSTN' : 'SenderGSTN']: data.GSTN,
          [isRecve ? 'recvGSTNState' : 'senderGSTNState']: gstData.State,
        })
        setGstnModal(true)
        setGstnValidationData({ data: gstData, isRecve: isRecve, showPopup: true, GSTN: data.GSTN, navigation: navigation })
      })
      .catch((err) => {
        setAlert({ show: true, msg: err.message, nextId: '' })
      })
      .finally(() => {
        setLoader(false)
      })
  }
  return (
    <>
      <div className="line--input--wrappers" style={{ display: 'flex', width: '100%' }}>
        <div style={{ display: 'flex', width: '49%' }}>
          <div style={{ width: '50%' }}>
            <div className="line--input--contents">
              <Box>
                <Item sx={{ background: '#f1f1f5', padding: 0, marginLeft: '10px' }}>
                  <div className={'input--wrapper'}>
                    <LineInput className="input-lable" type="text" label={au.lrNo || 'LR No.'} value={selectLr?.LRNo} disabled={true} />
                  </div>
                </Item>
              </Box>
            </div>
            <div className="line--input--contents">
              <Box>
                <Item sx={{ background: '#f1f1f5', padding: 0, marginLeft: '10px' }}>
                  <div className={'input--wrapper'}>
                    {selectLr?.IsSenderParty === 1 ? (
                      <DropDownOA
                        label={au.senderName || 'Sender Name'}
                        data={senderPartyList || []}
                        defaultvalue={selSenderParty?.Party}
                        width="100%"
                        searchPlaceholder={au.searchPartyName || 'Search Party Name'}
                        dataKey={`Party`}
                        idKey={`PartyID`}
                        id={iid.senderName}
                        prevId={iid.manualLr}
                        nextId={iid.SenderMobileNo}
                        // onSelect={(val) => {setSelSenderParty(val);setUpdatedVal({ ...updatedVal, SenderMobileNo: val.MobileNo })}}
                        onSelect={(val) => {
                          setSelSenderParty(val)
                          setUpdatedVal((prev) => ({
                            ...prev,
                            Sender: val.Party,
                            SenderMobileNo: val.MobileNo || '',
                          }))
                        }}
                      />
                    ) : (
                      <LineInputV2
                        id={iid.senderName}
                        type="text"
                        label={au.senderName || 'Sender Name'}
                        defaultvalue={selectLr?.Sender}
                        value={updatedVal.Sender}
                        filter={alphaNumericSpaceFilter}
                        onBlur={(e) => setUpdatedVal({ ...updatedVal, Sender: e.target.value })}
                        onKeyDown={(e) => lineInputNavigation2(e, iid.SenderMobileNo, iid.manualLr)}
                      />
                    )}
                  </div>
                </Item>
              </Box>
            </div>
            <div className="line--input--contents">
              <Box>
                <Item sx={{ background: '#f1f1f5', padding: 0, marginLeft: '10px' }}>
                  <div className={'input--wrapper'}>
                    <LineInputV2
                      id={iid.senderEmail}
                      type="text"
                      label={au.senderEmail || 'Sender Email'}
                      defaultvalue={selectLr?.SenderEmailID?.toLowerCase()}
                      value={updatedVal.SenderEmail}
                      onBlur={(e) => {
                        setUpdatedVal({ ...updatedVal, SenderEmail: e.target.value?.toLowerCase() })
                      }}
                      onKeyDown={(e) => lineInputNavigation2(e, iid.SenderGSTN, iid.SenderMobileNo)}
                    />
                  </div>
                </Item>
              </Box>
            </div>
            <div className="line--input--contents">
              <Box>
                <Item sx={{ background: '#f1f1f5', padding: 0, marginLeft: '10px' }}>
                  <div className={'input--wrapper'}>
                    <LineInputV2 id={iid.bookingCity} type="text" label={au.sourceCity || 'Source City'} value={selectLr?.BookingCity} disabled={true} />
                  </div>
                </Item>
              </Box>
            </div>
          </div>
          <div style={{ width: '50%' }}>
            <div className="line--input--contents">
              <Box>
                <Item sx={{ background: '#f1f1f5', padding: 0, marginLeft: '10px' }}>
                  <div className={'input--wrapper'}>
                    <LineInputV2
                      id={iid.manualLr}
                      type="text"
                      label={au.manulLrNumber || 'Manul LR Number'}
                      defaultvalue={selectLr?.ManualLRNo}
                      value={updatedVal.ManualLRNo}
                      disabled={
                        updatedVal.PaymentTypeId === paytypes.PAID_MANUAL ||
                        updatedVal.PaymentTypeId === paytypes.TO_PAY_MANUAL ||
                        updatedVal.PaymentTypeId === paytypes.ONACCOUNT_MANUAL
                          ? false
                          : true
                      }
                      onBlur={(e) => setUpdatedVal({ ...updatedVal, ManualLRNo: e.target.value })}
                      onKeyDown={(e) => lineInputNavigation2(e, iid.senderName, iid.senderName)}
                    />
                  </div>
                </Item>
              </Box>
            </div>
            <div className="line--input--contents">
              <Box>
                <Item sx={{ background: '#f1f1f5', padding: 0, marginLeft: '10px' }}>
                  <div className={'input--wrapper'}>
                    <LineInputV2
                      id={iid.SenderMobileNo}
                      type="text"
                      label={au.senderNo || 'Sender No.'}
                      value={updatedVal.SenderMobileNo}
                      filter={mobileNumberFilter}
                      onBlur={(e) => {
                        const sender = e.target.value
                        if (sender === updatedVal.RecMobileNo && companySettings?.DefaultCurrencyID !== 2) {
                          updateAlert({
                            show: true,
                            msg: au.senderReceiverMobileMustDiffer || 'Sender and Receiver mobile numbers must not be the same.',
                            nextId: 'SenderMobileNo',
                          })
                          return
                        }
                        if ((sender.length > loginData?.MobileNoULimit || sender.length < loginData?.MobileNoLLimit) && sender.length) {
                          updateAlert({ show: true, msg: au.pleaseEnterValidPhoneNo || SENDER_PHONE, nextId: 'SenderMobileNo' })
                          return
                        }
                        const dummy = ['6666666666', '7777777777', '8888888888', '9999999999']
                        if (dummy.includes(sender)) {
                          updateAlert({ show: true, msg: au.pleaseEnterValidPhoneNo || SENDER_PHONE, nextId: 'SenderMobileNo' })
                          return
                        }
                        setUpdatedVal((prev) => ({ ...prev, SenderMobileNo: sender }))
                      }}
                      onKeyDown={(e) => lineInputNavigation2(e, iid.senderEmail, iid.senderName)}
                    />
                  </div>
                </Item>
              </Box>
            </div>
            <div className="line--input--contents">
              <Box>
                <Item sx={{ background: '#f1f1f5', padding: 0, marginLeft: '10px' }}>
                  <div className={'input--wrapper'}>
                    <LineInputV2
                      id={iid.SenderGSTN}
                      type="text"
                      name={'SenGstnNo'}
                      label={au.senderGstn || 'Sender GSTN'}
                      defaultvalue={selectLr?.SenderGSTN}
                      value={updatedVal.SenderGSTN}
                      onBlur={(e) => {
                        if (isValidGSTNo(e.target.value)) {
                          if (e.target.value && ![GT_COMPANY_ID].includes(loginData.intCompanyID)) {
                            validateGSTN({ GSTN: e.target.value }, false, 1)
                          }
                        } else {
                          // setUpdatedVal({ ...updatedVal, SenderGSTN: e.target.value })
                          setUpdatedVal((prev) => ({ ...prev, SenderGSTN: e.target.value }))
                          // handleAlert('Enter Valid GST Number')
                        }
                      }}
                      onKeyDown={(e) => lineInputNavigation2(e, iid.RecName, iid.senderEmail)}
                    />
                  </div>
                </Item>
              </Box>
            </div>
            <div className="line--input--contents">
              <Box>
                <Item sx={{ background: '#f1f1f5', padding: 0, marginLeft: '10px' }}>
                  <div className={'input--wrapper'}>
                    <LineInputV2
                      id={iid.bookingBranchName}
                      type="text"
                      label={au.sourceBranch || 'Source Branch'}
                      defaultvalue={selectLr?.BookingBranchName}
                      value={selectLr?.BookingBranchName}
                      disabled={true}
                    />
                  </div>
                </Item>
              </Box>
            </div>
          </div>
        </div>
        <div style={{ width: '1.29%', borderRight: '2px solid rgb(0, 134, 255)', margin: '0 21px 13px 21px' }}>
          <span></span>

          <div>
            <div
              style={{
                width: '40px',
                position: 'relative',
                background: 'rgb(0, 134, 255)',
                height: '40px',
                display: 'flex',
                alignItems: 'center',
                borderRadius: '50%',
                margin: '80px 0',
              }}
            >
              <span
                style={{
                  position: 'absolute',
                  left: '10px',
                  right: '10px',
                  top: '48%',
                  height: '2px',
                  background: 'rgb(255, 255, 255)',
                  zIndex: '1',
                }}
              ></span>
              <span
                style={{
                  display: 'inline-block',
                  width: '10px',
                  height: '10px',
                  borderWidth: '2px 2px 0px 0px',
                  borderStyle: 'solid',
                  borderColor: 'rgb(255, 255, 255)',
                  borderImage: 'initial',
                  transform: 'rotate(45deg)',
                  background: 'rgb(0, 134, 255)',
                  right: '10px',
                  position: 'absolute',
                  top: '38%',
                }}
              ></span>
            </div>
          </div>
        </div>
        <div style={{ display: 'flex', width: '48.71%' }}>
          <div style={{ width: '50%' }}>
            <div className="line--input--contents">
              <Box>
                <Item sx={{ width: '100%', padding: '0 0 0 10px', marginBottom: '5%' }}>
                  <DropDownOA
                    id={iid.paymentTypes}
                    defaultvalue={selectLr?.PaymentType || '-'}
                    data={paymentTypes}
                    width="100%"
                    isObjArr={true}
                    dataKey="name"
                    idKey="typeId"
                    label={au.paymentType || 'Payment Type'}
                    searchPlaceholder={au.searchBookingType || 'Search Booking Type'}
                    // onSelect={(e) => {
                    //   if (selectLr?.PaymentTypeID === paytypes.PAID_MANUAL && e.typeId === paytypes.PAID) {
                    //     setUpdatedVal({ ...updatedVal, ManualLRNo: '' })
                    //     setUpdatedVal({ ...updatedVal, PaymentType: e.name, PaymentTypeId: e.typeId })
                    //   } else {
                    //     setUpdatedVal({ ...updatedVal, PaymentType: e.name, PaymentTypeId: e.typeId })
                    //   }
                    // }}
                    onSelect={(e) => {
                      const manualTypes = [paytypes.PAID_MANUAL, paytypes.TO_PAY_MANUAL, paytypes.ONACCOUNT_MANUAL]
                      const isManualType = manualTypes.includes(e.typeId)
                      const updatedObj = {
                        ...updatedVal,
                        PaymentType: e.name,
                        PaymentTypeId: e.typeId,
                        ManualLRNo: isManualType ? updatedVal.ManualLRNo : '',
                      }
                      setUpdatedVal(updatedObj)
                    }}
                    disabled={
                      selectLr?.PaymentTypeID === paytypes.PAID && ParentCompanyID === GT_COMPANY_ID
                        ? true
                        : [
                            paytypes.PAID,
                            paytypes.TO_PAY,
                            paytypes.COD,
                            paytypes.PAID_MANUAL,
                            paytypes.TO_PAY_MANUAL,
                            paytypes.SELF,
                            paytypes.TO_PAY_DDDV,
                          ].includes(selectLr?.PaymentTypeID) && loginData.intCompanyID !== STA_COMPANY_ID
                        ? false
                        : true
                    }
                  />
                </Item>
              </Box>
            </div>
            <div className="line--input--contents">
              <Box>
                <Item sx={{ background: '#f1f1f5', padding: 0, marginLeft: '10px' }}>
                  <div className={'input--wrapper'}>
                    {selectLr?.IsReceivedParty === 1 ? (
                      <DropDownOA
                        label={au.receiverName || 'Receiver Name'}
                        data={senderPartyList || []}
                        defaultvalue={selReceiverParty?.Party}
                        width="100%"
                        searchPlaceholder={au.searchPartyName || 'Search Party Name'}
                        dataKey={`Party`}
                        idKey={`PartyID`}
                        id={iid.RecName}
                        prevId={iid.manualLr}
                        nextId={iid.RecMobileNo}
                        // onSelect={(val) => setSelReceiverParty(val)}
                        onSelect={(val) => {
                          setSelReceiverParty(val)
                          setUpdatedVal((prev) => ({
                            ...prev,
                            RecName: val.Party,
                            RecMobileNo: val.MobileNo || '',
                          }))
                        }}
                      />
                    ) : (
                      <LineInputV2
                        id={iid.RecName}
                        type="text"
                        label={au.receiverName || 'Receiver Name'}
                        defaultvalue={selectLr?.RecName}
                        value={updatedVal.RecName}
                        onBlur={(e) => {
                          setUpdatedVal({ ...updatedVal, RecName: e.target.value })
                        }}
                        filter={alphaNumericSpaceFilter}
                        onKeyDown={(e) => lineInputNavigation2(e, iid.RecMobileNo, iid.SenderGSTN)}
                      />
                    )}
                  </div>
                </Item>
              </Box>
            </div>
            <div className="line--input--contents">
              <Box>
                <Item sx={{ background: '#f1f1f5', padding: 0, marginLeft: '10px' }}>
                  <div className={'input--wrapper'}>
                    <LineInputV2
                      id={iid.ReceiverEmailID}
                      type="text"
                      name={'SenGstnNo'}
                      label={au.receiverEmail || 'Receiver Email'}
                      defaultvalue={selectLr?.ReceiverEmailID?.toLowerCase()}
                      value={updatedVal.RecEmail}
                      onBlur={(e) => {
                        setUpdatedVal({ ...updatedVal, RecEmail: e.target.value?.toLowerCase() })
                      }}
                      onKeyDown={(e) => lineInputNavigation2(e, iid.ReceiverGSTN, iid.RecMobileNo)}
                    />
                  </div>
                </Item>
              </Box>
            </div>
            <div className="line--input--contents">
              <Box>
                <Item sx={{ background: '#f1f1f5', padding: 0, marginLeft: '10px' }}>
                  <DropDownOA
                    type={SEL_DESTINATION_CITY}
                    label={au.destinationCity || 'Destination City'}
                    data={destCitiesList.filter((val) => val.CityID !== selectLr?.BookingCityID) || []}
                    defaultvalue={selectLr?.DestinationCity}
                    //defaultvalue={destCity ? destCity?.CityName : ''}
                    width="100%"
                    searchPlaceholder={au.searchDestinationCity || 'Search Destination City'}
                    typeOf={1}
                    isObjArr={true}
                    dataKey={`CityName`}
                    idKey={`CityID`}
                    id={iid.destinationCity}
                    tabIndex="4"
                    prevId={iid.ReceiverGSTN}
                    nextId={iid.destbranch}
                    onSelect={(e) => {
                      setUpdatedVal((prev) => ({ ...prev, DestCityID: e.CityID, DestBranchID: 0 }))
                      setSelectedDestBranchName('')
                      handleBranchList(e.CityID)
                      setClearBranch(true)
                    }}
                    disabled={roleRights?.Table1?.[0]?.AllowAdminDestinationChange === 0}
                  />
                </Item>
              </Box>
            </div>
          </div>
          <div style={{ width: '50%', marginRight: '10px' }}>
            <div className="line--input--contents">
              <Box>
                <Item sx={{ background: '#f1f1f5', padding: 0, marginLeft: '10px' }}>
                  <div className={'input--wrapper'}>
                    <LineInputV2
                      id={iid.challanNo}
                      type="text"
                      label={au.challanNo || 'Challan No.'}
                      defaultvalue={selectLr?.VoucherNo}
                      value={selectLr?.VoucherNo}
                      disabled={true}
                    />
                  </div>
                </Item>
              </Box>
            </div>
            <div className="line--input--contents">
              <Box>
                <Item sx={{ background: '#f1f1f5', padding: 0, marginLeft: '10px' }}>
                  <div className="input--wrapper">
                    <LineInputV2
                      id={iid.RecMobileNo}
                      type="text"
                      label={au.receiverNo || 'Receiver No.'}
                      value={updatedVal.RecMobileNo || ''}
                      filter={mobileNumberFilter}
                      onBlur={(e) => {
                        const receiver = e.target.value
                        if (receiver === updatedVal.SenderMobileNo && companySettings?.DefaultCurrencyID !== 2) {
                          updateAlert({
                            show: true,
                            msg: au.senderReceiverMobileMustDiffer || 'Sender and Receiver mobile numbers must not be the same.',
                            nextId: 'RecMobileNo',
                          })
                          return
                        }
                        if (
                          (receiver.length > loginData?.MobileNoULimit || receiver.length < loginData?.MobileNoLLimit) &&
                          receiver.length
                        ) {
                          updateAlert({
                            show: true,
                            msg: SENDER_PHONE,
                            nextId: 'RecMobileNo',
                          })
                          return
                        }
                        const dummy = ['6666666666', '7777777777', '8888888888', '9999999999']
                        if (dummy.includes(receiver)) {
                          updateAlert({
                            show: true,
                            msg: SENDER_PHONE,
                            nextId: 'RecMobileNo',
                          })
                          return
                        }
                        setUpdatedVal((prev) => ({
                          ...prev,
                          RecMobileNo: receiver,
                        }))
                      }}
                      onKeyDown={(e) => lineInputNavigation2(e, iid.ReceiverEmailID, iid.RecName)}
                    />
                  </div>
                </Item>
              </Box>
            </div>
            <div className="line--input--contents">
              <Box>
                <Item sx={{ background: '#f1f1f5', padding: 0, marginLeft: '10px' }}>
                  <div className={'input--wrapper'}>
                    <LineInputV2
                      id={iid.ReceiverGSTN}
                      type="text"
                      name={'SenGstnNo'}
                      label={au.receiverGstn || 'Receiver GSTN'}
                      defaultvalue={selectLr?.ReceiverGSTN}
                      value={updatedVal.ReceiverGSTN}
                      onBlur={(e) => {
                        if (isValidGSTNo(e.target.value)) {
                          if (e.target.value !== '' && ![GT_COMPANY_ID].includes(loginData.intCompanyID)) {
                            validateGSTN({ GSTN: e.target.value }, true, 2)
                          }
                        } else {
                          setUpdatedVal((prev) => ({ ...prev, ReceiverGSTN: e.target.value }))
                          // setUpdatedVal({ ...updatedVal, ReceiverGSTN: e.target.value })
                          // handleAlert('Enter Valid GST Number')
                        }
                      }}
                      onKeyDown={(e) => navigation2(e, iid.destinationCity, iid.ReceiverEmailID)}
                    />
                  </div>
                </Item>
              </Box>
            </div>
            <div className="line--input--contents">
              <Box>
                <Item sx={{ background: '#f1f1f5', padding: 0, marginLeft: '10px' }}>
                  {/* <DropDownOA
                    type={SEL_DESTINATION_BRANCH}
                    label={au.destinationBranch || 'Destination Branch'}
                    data={destinationBranchList}
                    width="100%"
                    searchPlaceholder={au.searchDestinationBranch || 'Search Destination Branch'}
                    typeOf={2}
                    defaultvalue={selectedDestBranchName}
                    isObjArr={true}
                    dataKey={`BranchName`}
                    idKey={`BranchID`}
                    tabIndex="6"
                    id={iid.destbranch}
                    prevId={iid.destinationCity}
                    nextId={iid.updateButton}
                  /> */}
                  <DropDownOA
                    // type={SEL_DESTINATION_BRANCH}
                    label={au.destinationBranch || 'Destination Branch'}
                    data={adminBranchList || []}
                    width="100%"
                    searchPlaceholder={au.searchDestinationBranch || 'Search Destination Branch'}
                    typeOf={2}
                    defaultvalue={selectedDestBranchName}
                    value={selectedDestBranchName}
                    isObjArr={true}
                    dataKey={`BranchName`}
                    idKey={`BranchID`}
                    tabIndex="6"
                    id={iid.destbranch}
                    prevId={iid.destinationCity}
                    nextId={iid.updateButton}
                    resetFlag={clearBranch}
                    disabled={roleRights?.Table1?.[0]?.AllowAdminDestinationChange == 0}
                    onSelect={(e) => {
                      setUpdatedVal((prev) => ({ ...prev, DestBranchID: e.BranchID }))
                      setSelectedDestBranchName(e.BranchName || '')
                      setClearBranch(false)
                    }}
                  />
                </Item>
              </Box>
            </div>
          </div>
        </div>
      </div>
      <div style={{ display: 'flex', textAlign: 'right', justifyContent: 'right', marginRight: '10px' }}>
        <Box sx={{ flexGrow: 1, width: '100%', display: 'inline-flex', padding: '0% 10px' }}>
          <Item sx={{ width: '50%' }}>
            {' '}
            <div className={'input--wrapper'} style={{ width: '100%' }}>
              <LineInput
                disabled={false}
                id={`bill_no`}
                label={au.billNo || 'Bill No'}
                // value={'+91'}
                width="11%"
                type="text"
                name="S_code"
                value={billNo}
                onChange={(e) => handleChange(e, 'billNo')}
                sx={{ margin: '8px', width: '100%' }}
              />
            </div>
          </Item>
          <Item sx={{ width: '25%' }}>
            <div className="input--container" style={{ width: '100%' }}>
              <Datepicker
                name={'filter_from_dt'}
                dateChange={(date) => setBillDate(date)}
                value={billDate}
                date={billDate}
                type="filter_from_dt"
                statusChecked={false}
                label={au.selectDate || 'Select Date'}
              />
            </div>
          </Item>
          <Item sx={{ width: '25%' }}>
            <div className={'input--wrapper'} style={{ width: '100%' }}>
              <LineInput
                disabled={false}
                id={`S_code`}
                label={au.billAmount || 'Bill Amount'}
                // value={'+91'}
                width="11%"
                type="text"
                name="S_code"
                value={billAmount}
                onChange={(e) => handleChange(e, 'billAmt')}
                sx={{ margin: '8px', width: '100%' }}
              />
            </div>
          </Item>
        </Box>
        <Item sx={{ background: '#fff', border: '1px solid #f15a22', textAlign: 'center', margin: '10px', height: '47px' }}>
          <Button
            variant="outlined"
            sx={{ width: '10%', height: '-webkit-fill-available' }}
            style={{ borderColor: '#fff', color: '#f15a22', fontSize: '15px', fontWeight: 'bold', textTransform: 'Uppercase' }}
            onClick={() => updateModal()}

            //   disabled={cancelEdit == true ? true : false}
          >
            {' '}
            {au.cancel || 'CANCEL'}
          </Button>
        </Item>
        <Item
          sx={{
            width: '10%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginTop: '0px',
            padding: '0',
            //   backgroundColor: '#f0fcf4',
          }}
        >
          <Button
            id={iid.updateButton}
            variant="contained"
            className="btn btn-primary"
            autoFocus={false}
            onClick={() => {
              UpdateSendRecDetails()
            }}
            sx={{
              width: '100%',
              padding: '10px',
              letterSpacing: '2px',
            }}
            //   onKeyDown={(e) => handleIdSaveButton(e, '', iid.comment)}
          >
            {au.update || 'UPDATE'}
          </Button>
        </Item>
      </div>
      {gstnModal && <GstnValidationUi updateModal={updateModal} gstnValidationData={gstnValidationData} setGstnModal={setGstnModal} />}
      {otpPopupVisible && <ShowStickerCopyPopup />}
      {showModel && (
        <DestinationChangeRemarkMode
          updateModal={handleClose}
          setShowModel={setShowModel}
          loginData={loginData}
          setTextAreaValue={setTextAreaValue}
          updateSendetReceiverDetails={UpdateSendRecDetails}
        />
      )}
    </>
  )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = {
  updateModal,
  updateAlert,
  SenderReceiverDetailChange,
  updateDestCity,
  updateDestBrnch,
  getBranchList,
  getBranchConfigOrEwbillinfo,
  getBranchListForAdminUpdate,
}
export default connect(mapStateToProps, mapDispatchToProps)(SenderReceiverTab)
